import React from "react";
import RequestInbox from "../../components/RequestInbox";
import "./style.scss";

const RequestInboxPage = () => {
  return (
    <div className="request_inbox_page">
      <RequestInbox />
    </div>
  );
};

export default RequestInboxPage;
